
import { Achievement } from "@/hooks/use-achievements";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { format } from "date-fns";

interface AchievementBadgeProps {
  achievement: Achievement;
  size?: "sm" | "md" | "lg";
}

export function AchievementBadge({ achievement, size = "md" }: AchievementBadgeProps) {
  const sizeClasses = {
    sm: "p-3 text-xs",
    md: "p-4 text-sm",
    lg: "p-6 text-base"
  };

  const iconSizes = {
    sm: "text-lg",
    md: "text-xl",
    lg: "text-2xl"
  };

  return (
    <Card className={`${achievement.unlocked ? 'bg-gradient-to-br from-yellow-50 to-orange-50 border-yellow-200' : 'bg-gray-50 border-gray-200'} transition-all duration-200`}>
      <CardContent className={sizeClasses[size]}>
        <div className="flex items-start gap-3">
          <div className={`${iconSizes[size]} ${achievement.unlocked ? 'grayscale-0' : 'grayscale opacity-50'} flex-shrink-0`}>
            {achievement.icon}
          </div>
          <div className="flex-1 min-w-0">
            <h4 className={`font-medium text-sm leading-tight mb-1 ${achievement.unlocked ? 'text-gray-900' : 'text-gray-500'}`}>
              {achievement.title}
            </h4>
            <p className={`text-xs leading-relaxed ${achievement.unlocked ? 'text-gray-600' : 'text-gray-400'}`}>
              {achievement.description}
            </p>
            {achievement.unlocked && achievement.unlockedAt && (
              <Badge variant="secondary" className="mt-2 text-xs">
                Unlocked {format(new Date(achievement.unlockedAt), 'MMM d, yyyy')}
              </Badge>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
